import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@ts-digital/vrc";
import { Input, Select, Table } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getDraftIdFromOriginalEntry } from "../../../../store/actions/precog";
import { getFixedUsedGoodsList } from "../../../../store/actions/usedGoods";
import Page from "../../../general/page";
import Spinner from "../../../general/spinner";
import { VaporDatePicker } from "../../../vapor";
import EmptyState from "../../../vapor/emptyState";
import "./style.scss";
const Option = Select.Option;

const FixedUsedGoods = ({pageRef}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const company = useSelector(state => state.company);
  const main = useSelector(state => state.main);
  const selectedCompanyName = company?.companies?.find(el => el.id === main.clientIdSelected);
  const [originalList, setOriginalList] = useState([]);  
  const [filteredList, setFilteredList] = useState(null);  
  const [isLoadingList, setIsLoadingList] = useState(false);  
  const [filtersTable, setFiltersTable] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoadingList(true);
    dispatch(getFixedUsedGoodsList()).then(el => {
      setFilteredList(el);
      setOriginalList(el);
      setIsLoadingList(false);
    }).catch(e => {
      setIsLoadingList(false);
    });
  }, []);

  useEffect(() => {
    const filterNew = originalList.filter(function(item) {
      for (let key in filtersTable) {                
        if (filtersTable[key] && (item[key] === undefined || !(item[key].toString()).includes(filtersTable[key])))
          return false;
      }
      return true;
    });

    setFilteredList(filterNew);
      
  }, [filtersTable]);
  
  const handleChange = (filterKey, value) => {
    setFiltersTable({
      ...filtersTable,
      [filterKey]: value
    });
  };

  const goToDetails = (record) => {
    dispatch(getDraftIdFromOriginalEntry(record.id)).then((res) => {      
      navigate(`/precog-detail/${res}`, {state: {goBack: true}});         
    }).catch(err => {

    });
  };
  const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY", "DDMMYYYY", "DDMMYY"];
  const columns = [
    {
      title: intl.formatMessage({ id: "preCog.usedGoods.fixed.description"}),
      dataIndex: "description",
      render: value => (value === "initial" ?
        <div className="transparent noBorder">
          <Input         
            allowClear={true}
            placeholder={intl.formatMessage({ id: "preCog.usedGoods.fixed.search"})}
            onChange={(e) => handleChange("description", e.target.value)}
          />     
        </div>         
        : value),
      sorter: (a, b) => { return a.description ==="initial" || b.description ==="initial" ? 0 : a.description.localeCompare(b.description);}
    },
    {
      title: intl.formatMessage({ id: "preCog.usedGoods.fixed.idCode" }),
      dataIndex: "identificationCode",
      render: value => (value === "initial" ? <div className="transparent noBorder">
        <Input         
          allowClear={true}
          placeholder={intl.formatMessage({ id: "preCog.usedGoods.fixed.search"})}
          onChange={(e) => handleChange("identificationCode", e.target.value)}
        />    
      </div> : value),
      sorter: (a, b) => { return a.identificationCode ==="initial" || b.identificationCode ==="initial" ? 0 : a.identificationCode.localeCompare(b.identificationCode);}
    },
    {
      title: intl.formatMessage({ id: "preCog.usedGoods.fixed.buyDate" }),
      dataIndex: "buyDate",
      render: value => (value === "initial" ?
        <>
          <VaporDatePicker
            format={dateFormatList}
            getPopupContainer={(trigger) => trigger.parentNode}
            placeholder={intl.formatMessage({ id: "preCog.usedGoods.fixed.search"})}
            allowClear={true}
            className="date-search transparent noBorder"
            onChange={(e) => e ? handleChange("buyDate", moment(e).format(DATE_FORMAT_FOR_API)) : handleChange("buyDate", null)}
          />
        </> : <span>{moment(value).format("DD/MM/YYYY")}</span>),
      sorter: (a, b) => { return a.buyDate ==="initial" || b.buyDate ==="initial" ? 0 : ((a.buyDate > b.buyDate) - (a.buyDate < b.buyDate));}
    },   
    {
      title: intl.formatMessage({ id: "preCog.usedGoods.fixed.sellDate" }),
      dataIndex: "sellDate",
      render: value => (value === "initial" ?
        <>
          <VaporDatePicker
            format={dateFormatList}
            getPopupContainer={(trigger) => trigger.parentNode}
            placeholder={intl.formatMessage({ id: "preCog.usedGoods.fixed.search"})}
            allowClear={true}
            className="date-search transparent noBorder"
            onChange={(e) => e ? handleChange("sellDate", moment(e).format(DATE_FORMAT_FOR_API)) : handleChange("sellDate", null)}
          />
        </> : <span>{moment(value).format("DD/MM/YYYY")}</span>),
      sorter: (a, b) => { return a.sellDate ==="initial" || b.sellDate ==="initial" ? 0 : ((a.sellDate > b.sellDate) - (a.sellDate < b.sellDate));}
    },
    {
      title: intl.formatMessage({ id: "preCog.usedGoods.fixed.totalPurchase" }),
      dataIndex: "totalPurchase",
      render: value => (value === "initial" ? <div className="transparent noBorder">
        <Input                   
          allowClear={true}
          placeholder={intl.formatMessage({ id: "preCog.usedGoods.fixed.search"})}
          onChange={(e) => handleChange("totalPurchase", e.target.value)}
        />    
      </div> : value),
      sorter: (a, b) => { return a.totalPurchase ==="initial" || b.totalPurchase ==="initial" ? 0 : a.totalPurchase.localeCompare(b.totalPurchase);}
    },
    {
      title: intl.formatMessage({ id: "preCog.usedGoods.fixed.marginAmount" }),
      dataIndex: "marginAmount",
      render: value => (value === "initial" ? 
        <div className="transparent noBorder">
          <Input         
            className="transparent noBorder"
            allowClear={true}
            placeholder={intl.formatMessage({ id: "preCog.usedGoods.fixed.search"})}
            onChange={(e) => handleChange("marginAmount", e.target.value)}
          />    
        </div> : (value | 0) + "€"),
      sorter: (a, b) => { return a.marginAmount ==="initial" || b.marginAmount ==="initial" ? 0 : a.marginAmount.localeCompare(b.marginAmount);}
    },
    {
      title: intl.formatMessage({ id: "preCog.usedGoods.fixed.accessories" }),
      dataIndex: "accessories",
      render: value => (value === "initial" ? 
        <div className="transparent noBorder">
          <Input         
            className="transparent noBorder"
            allowClear={true}
            placeholder={intl.formatMessage({ id: "preCog.usedGoods.fixed.search"})}
            onChange={(e) => handleChange("accessories", e.target.value)}
          />    
        </div> : (value | 0) + "€"),
      sorter: (a, b) => { return a.accessories ==="initial" || b.accessories ==="initial" ? 0 : a.accessories.localeCompare(b.accessories);}
    },    
    {
      title: intl.formatMessage({ id: "preCog.usedGoods.fixed.status" }),
      dataIndex: "status",
      width: 120,
      render: value => (value === "initial" ?
        <Select
          className="input-search transparent noBorder"
          allowClear={true}
          placeholder={intl.formatMessage({ id: "all"})}
          onChange={(val) => handleChange("status",val)}
        >
          <Option value="NOT_SOLD"><FormattedMessage id={"preCog.usedGoods.fixed.table.NOT_SOLD"} /></Option>
          <Option value="SOLD"><FormattedMessage id={"preCog.usedGoods.fixed.table.SOLD"} /></Option>          
        </Select>        
        : 
        <FormattedMessage id={`preCog.usedGoods.fixed.table.${value}`} />
      ),
      sorter: (a, b) => { return a.status ==="initial" || b.status ==="initial" ? 0 : a.status.localeCompare(b.status);}
    },
    {
      title: "",
      dataIndex: "action",
      render: (value, record) => (value === "initial" ?
        null : <FontAwesomeIcon style={{color: "#0090d1", cursor: "pointer"}} 
          icon={["far", "external-link-square-alt"]} onClick={() => {            
            goToDetails(record);            
          }
          } />)      
    }
  ];

  const initial = {
    key: "initial",
    description: "initial",
    identificationCode: "initial",
    buyDate: "initial",
    sellDate: "initial",
    totalPurchase: "initial",
    marginAmount: "initial",
    accessories: "initial",
    status: "initial",
    action: "initial"
  };

  return (
    <Page
      pageRef={pageRef}
      title={intl.formatMessage({ id: "usedGoods.title" })}
      subtitle={
        selectedCompanyName?.ragioneSociale + " / " + intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" }) + " " + main.companySelected
      }
      className={"contentStructure transparent"}
      subClassName="pageCss"   
    >
      {
        isLoadingList ?
          <Spinner /> :
          <div style={{margin: "16px 32px" }}> 
            <Table
              className="vaporTable" 
              columns={columns}
              dataSource={filteredList ? [initial, ...filteredList] : [initial]}    
              pagination={false}      
            />
            {!filteredList || filteredList.length === 0 &&
      <EmptyState withIcon={true} 
        title={intl.formatMessage({ id: "preCog.usedGoods.fixed.table.empty.title" })}
        description={intl.formatMessage({ id: "preCog.usedGoods.fixed.table.empty.description" })}
      />
            }
          </div>
      }         
      <footer className="usedGoods-footer">
        <Button kind="primary" size="large" onClick={() => navigate(-1)} >
          {" "}
          <FormattedMessage id="close" />{" "}
        </Button>
      </footer>
    </Page>
  );
};

export default FixedUsedGoods;